export const SHARE_CONTENT_CLASS_NAME = "mx-auto w-[calc(100%_-_32px)] max-w-[1200px] sm:w-[calc(100%_-_64px)] lg:w-[calc(100%_-_96px)] min-[1440px]:w-[calc(100%_-_128px)]";
